var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[`tooltip-with-info-icon tooltip-with-info-icon--${_vm.alignment}`,
                {'tooltip-with-info-icon--inline': _vm.inline}]},[_c('i',[_c('icon-question',{attrs:{"width":"14","height":"14"}})],1),_c('div',{staticClass:"tooltip"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }